import { useEffect, useState, useCallback } from "react";

export function useLocalStorage<StorageType>(storageKey: string) {
  const [configuration, setConfiguration] = useState<StorageType | null>(null);

  useEffect(() => {
    setConfiguration(JSON.parse(localStorage.getItem(storageKey) || "null"));

    function onStorageChange(event: StorageEvent) {
      if (event.key === storageKey)
        setConfiguration(JSON.parse(event.newValue || "null"));
    }

    addEventListener("storage", onStorageChange);
    return () => {
      removeEventListener("storage", onStorageChange);
    };
  }, [storageKey]);

  const partialSetter = useCallback(
    (config: Partial<StorageType>) => {
      const oldValue = localStorage.getItem(storageKey);
      const oldConfig = JSON.parse(oldValue || "null");
      const newValue = JSON.stringify({ ...oldConfig, ...config });
      localStorage.setItem(storageKey, newValue);
      dispatchEvent(
        new StorageEvent("storage", {
          storageArea: localStorage,
          url: location.href,
          key: storageKey,
          newValue,
          oldValue
        })
      );
    },
    [storageKey]
  );

  return [configuration, partialSetter] as const;
}
